
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';
import { PasswordValidationCCDto } from '../../dto/passwordvalidationcc/passwordvalidationccdto';


export interface PasswordValidationCCRequest extends APIRequest
{
    getPasswordValidationCCRequest(): PasswordValidationCCDto;
}

export class PasswordValidationCCRequestImpl extends APIRequestDtoImpl implements PasswordValidationCCRequest
{
    constructor(private PasswordValidationCCData: PasswordValidationCCDto)
    {
        super();
    }

    getPasswordValidationCCRequest(): PasswordValidationCCDto
    {
        return this.PasswordValidationCCData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/passwordvalidationcc/passwordvalidationccrequest.tsx